// ScoreGrid.js
import React from 'react';
import PropTypes from 'prop-types';

export default function ScoreGrid({ scores, categories }) {
  if (!scores || !categories) return null;

  return (
    <div>
      {Object.entries(categories).map(([categoryName, items]) => (
        <fieldset key={categoryName} className="mb-4">
          <legend className="fw-bold text-uppercase small border-bottom pb-1 mb-2">{categoryName}</legend>
          <div className="row">
          {items.map(([key, label]) => {
                const val = scores[key];
                const numericScore = parseFloat(val?.score ?? '0'); // Fallback to '0' if val or val.score is undefined/null
              if (!val || isNaN(numericScore)) {
                console.warn('Missing or invalid score for:', key, val);
                return null;
              }
              return (
                <div className="col-md-6 mb-3" key={key}>
                  <div className="border p-2 rounded">
                    <h6 className="mb-1">
                      {label} <span className="badge bg-info">{val.score}/10</span>
                    </h6>
                    <p className="mb-1"><em>{val.explanation}</em></p>
                    {Array.isArray(val.improvementSuggestions) && val.improvementSuggestions.length > 0 && (
                      <ul className="mb-0 text-muted small">
                        {val.improvementSuggestions.map((s, idx) => (
                          <li key={idx}>{s}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </fieldset>
      ))}
    </div>
  );
}

ScoreGrid.propTypes = {
  scores: PropTypes.object.isRequired,
  categories: PropTypes.objectOf(
    PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
  ).isRequired,
};
